import { useEffect, useState } from "react";
import { getSettings } from "../services/settingsService";

const usePaymentMethods = () => {
  const [methods, setMethods] = useState([]);

  useEffect(() => {
    const fetchSettings = async () => {
      const settings = await getSettings();

      setMethods([
        { value: "razorpay", label: "Razorpay", icon: require("../assets/images/raz.png"), status: settings?.razorpay_enabled },
        { value: "paypal", label: "PayPal", icon: require("../assets/images/paypal.png"), status: settings?.paypal_enabled },
        { value: "banking", label: "Banking AC", icon: require("../assets/images/bank.png"), status: settings?.bank_transfer_enabled },
        { value: "payu", label: "PayU", icon: "🏦", status: settings?.payu_enabled },
        { value: "paytm", label: "Paytm", icon: "📱", status: settings?.paytm_enabled },
        { value: "upi", label: "UPI", icon: "📲", status: settings?.upi_enabled },
        { value: "netbanking", label: "Net Banking", icon: "🌐", status: settings?.netbanking_enabled },
        { value: "card", label: "Credit/Debit Card", icon: "💳", status: settings?.card_enabled },
      ]);
    };

    fetchSettings();
  }, []);

  console.log('methods', methods);

  return methods;
};

export default usePaymentMethods;
